// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getServiceListStatus: { data: null },
  getTechnicianListStatus: { data: null },
  createProductStatus: { data: null },
  updateProductStatusStatus: { data: null },
  getProductStatus: { data: null },
  deleteProductStatus: { data: null },
  uploadImageStatus: { data: null },
  getSalesListStatus: { data: null },
  getServiceByIdStatus: { data: null },
  getServiceReportListStatus: { data: null },
  getServiceSchedulingListStatus: { data: null, loading: false },
  getServiceReportByIdStatus: { data: null },
  getAllReportListStatus: { data: null },
  getServiceSchedulingByIdStatus: { data: null },
};
